module.exports = __webpack_public_path__ + "img/30_BF8_stay_close_to_home.dbea4142.jpg";